export function ContactRu(props) {
    return (<p className={'description-text'}>
        Продажи и Сотрудничество <br/> sales@overcom.dev <br/> <p>Техническая
        поддержка <br/> support_prod@overcom.dev</p>  <p> Дополнительная информация <br/> Пресса:
        pr@overcom.dev <br/> Карьера: job@overcom.dev <br/> Общие вопросы: office@overcom.dev <br/></p> Наш
        адрес <br/>
        ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ОВЕРКОМ"
        <br/>ИНН 6164029306
        <br/> Пер.
        Доломановский, 70Д
        (Бизнес-центр Гвардейский)<br/>17-й этаж оф.9 Ростов-на-Дону 344011
    </p>);
}

export function ContactEn(props) {
    return (<p className={'description-text'}>
        Sales and Cooperation <br/> sales@overcom.dev <br/> <p>Technical support <br/> support_prod@overcom.dev</p>
        <p>Additional Information <br/> Press:
            pr@overcom.dev <br/> Career: job@overcom.dev <br/> General: office@overcom.dev <br/></p> Our address 
            <br/>
            Limited Liability Company "OVERCOM"
        <br/>ITN 6164029306
            <br/>Per.
        Dolomanovskiy, 70D (Business Center Gvardeyskiy) <br/> 17th floor, office 9
        Rostov-on-Don 344011 Russia
    </p>);
}
